import { PrimaryProviderUser } from "../../../types/models/ProviderUser";
import ProviderUserName from "./ProviderUserName";
import { providerUserApi } from "../../../apis/ProviderUser.api.ts";
import {linkPath as linkPathParent} from "../../../../timber/components/provider/ProviderDetail/ProviderLink";    
import * as React from 'react';
import { NavLink } from "react-router";
import Link, { LinkProps } from '@mui/material/Link';
import {useDispatch} from "react-redux";
import {ID} from "../../../../types/global";
import {ReactElement} from "react";

interface LinkRouterProps extends LinkProps {
    to: string;
    replace?: boolean;
}

type IFormProps = {
    icon: ReactElement,
    id: ID;

};

function LinkRouter(props: LinkRouterProps) {
    return <Link {...props} component={NavLink as any} />;
}

export const linkPath = async (dispatch, id) => {
    const {data} = await dispatch(providerUserApi.endpoints.getProviderUser.initiate(PrimaryProviderUser.fromId(id)))
    const prefix = await linkPathParent(dispatch, data.providerId)
    return `${prefix}/provider-users/${PrimaryProviderUser.fromId(id).toPath()}`
}

const ProviderUserLink: React.FC<IFormProps> = ({id, icon}) => {
    
    const dispatch = useDispatch()
    const [link, setLink] = React.useState('')
    
    React.useEffect(() => {
        linkPath(dispatch, id)
            .then(setLink)
    }, [id])

    if (id)
        if (link)
            return (
                <LinkRouter to={ `/dashboard${link}` } viewTransition={true}>
                    <ProviderUserName id={id}/> { icon && icon }
                </LinkRouter>
            )
        else
            return (<ProviderUserName id={id}/>)
    else
        return undefined
}
export default ProviderUserLink;
